/**
 * Imports
 *
 * Import any modules or components here.
 */
import { createElement } from "commonAssets/lib/createElement.js";

/**
 * Header Class
 *
 * Represents a header element with site name, case number, and court name.
 *
 * @constructor
 * @param {string} siteName - The name of the website.
 * @param {string} caseNumber - The case number.
 * @param {string} courtName - The name of the court.
 * @property {string} siteName - The name of the website.
 * @property {string} caseNumber - The case number.
 * @property {string} courtName - The name of the court.
 * @property {HTMLElement} element - The header element.
 * @method createHeader - Creates the header element with site name, case number, and court name.
 * @returns {HTMLElement} - The header element.
 */
export class Header {
    constructor(siteName, caseNumber, courtName) {
        this.siteName = siteName;
        this.caseNumber = caseNumber;
        this.courtName = courtName;
        this.element = this.createHeader();
    }

    createHeader() {
        const row = createElement("div", { class: "row" });
        const col = createElement("div", { class: "col" });
        const siteNameHeader = createElement(
            "h1",
            { class: "fs-1 my-1 fw-normal", id: "site-name" },
            [],
            this.siteName
        );
        const caseNumberHeader = createElement(
            "div",
            { class: "fs-5 my-1 fw-normal", id: "case-number" },
            [],
            this.caseNumber
        );
        const courtNameHeader = createElement(
            "div",
            { class: "fs-5 my-1 fw-normal", id: "court-name" },
            [],
            this.courtName
        );

        col.append(siteNameHeader, caseNumberHeader, courtNameHeader);
        row.appendChild(col);

        return createElement("div", { class: "container" }, [row]);
    }
}
